<template>
  <div class="lms-wrapper-two">
    <student-nav @on-filter="onFilterLib" :obj.sync="statObj"></student-nav>
    <div class="lms-content">
      <student-header ref="stdnthdr" filterTypeHolder="Бүх төрөл ..." filterName="Ном хайх ..." @loctype-slcd="filterParams.type=$event"
      class="filled" @toggle-navbar="toggleNavbar($event)" @on-filter="doFilter(5, $event)"
      @loctype-cleared="loctypeCleared" />
      <div
        class="container lms-content-body"
        style="bottom: 0; "
      >
        <template v-if="($route.params.m == 0 || $route.params.m == 101 ||
        $route.params.m == 102 || $route.params.m == 103 ||
         $route.params.m == 5 || $route.params.m == 6)">
          <section v-if="$route.params.id == 0 || $route.params.id == 101 || $route.params.id == 102 || $route.params.id == 103">
            <!-- <ul class="nav nav-line nav-line-profile mg-b-30">
              <li class="nav-item">
                <router-link
                  :to="{
                    name: 'lmsLibrary',
                    params: { id: 0, cid: 0, title: 'Номын сан' },
                  }"
                  class="nav-link d-flex align-items-center"
                  :class="{ active: $route.params.cid == 0 }"
                  >Бүх ном
                  <span class="badge">{{ allCount }}</span></router-link
                >
              </li>
              <li class="nav-item" v-for="(c, i) in categories" :key="i">
                <router-link
                  :to="{
                    name: 'lmsLibrary',
                    params: { id: 0, cid: c.id, title: c.s1 },
                  }"
                  class="nav-link d-flex align-items-center"
                  :class="{ active: $route.params.cid == c.id }"
                  >{{ c.s1 }}</router-link
                >
              </li>
            </ul> -->
            <vue-custom-scrollbar :style="`height: ${getScrollHeight()}`" class="pd-t-30">
            <!-- {{ $route.name }} -->
              <div
                class="row course-list mg-b-25 books pd-lg-x-80 pd-lg-xl-120"
                style="margin-right: 0; margin-left: 0;"
              >
                <div
                  v-for="(t, i) in tasks"
                  :key="i"
                  @click="readEbook(t)"
                  class="course-item col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 col-xxl-3 pd-10"
                >
                <!-- aa -->
                  <div
                    v-if="isNewBook(t) "
                    class="text-white course-tag pos-absolute r-10 t-20 pd-x-20 pd-y-1 tx-14 bg-primary"
                  >
                  <!-- || t.i2!=0 -->
                    <span>шинэ</span> 
                    <!-- <span v-if="t.i2!=0">үлдэгдэл: {{ t.too1 }}</span> -->
                  </div>
                  <div class="bg-white pd-20 rounded-20 item-outer">
                    <img
                      :src="`${t.defaultAttachmentUrl}?w=400&h=400&mode=crop`"
                      class="cover rounded-20 wd-100p "
                    />
                    <div class="item-info pd-10 d-flex align-items-center">
                      <div class="media-body">
                        <div class="course-name tx-16 font-weight-bold lh-1 text-rows-2">
                          {{ t.task }}
                        </div>
                        <div class="text-muted tx-10">{{ t.st1 }}</div>
                      </div>
                    </div>
                    <div class="text-center pd-lg-x-40">
                      <!-- <a class="btn btn-white rounded-20 btn-block">{{ t.secondAttachmentId>0?'Цахим ном':'Биет ном' }}</a> -->
                      <a class="btn btn-white rounded-20 btn-block">{{ t.i2==0?'Цахим ном':'Биет ном' }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </vue-custom-scrollbar>
          </section>
          <section v-if="$route.params.id > 0">
            <template v-if="$route.params.m == 5">              
              <book-detail></book-detail>
            </template>
            <template v-else-if="($route.params.m == 6)">
              <read></read>
            </template>
          </section>
        </template>
        <div class="card" v-else-if="$route.params.m == 1">
          <div class="card-header d-flex justify-content-between">
            <h6 class="lh-5 mg-b-0">Ном захиалга</h6>
            <b-pagination
              v-if="allCount > 0"
              class="mg-r-20"
              size="sm"
              align="center"
              v-model="pager.page"
              :total-rows="allCount"
              :per-page="pager.size"
              @change="pageChanged"
              style="margin-bottom: 0"
            ></b-pagination>
          </div>
          <div class="card-body pd-x-0 pd-y-10">
            <vue-custom-scrollbar :style="`height: ${getScrollHeight(195)}`">
              <lib-books
                :tasks="tasks"
                :nowDate="nowDate"
                @on-order="orderBook"
              />
            </vue-custom-scrollbar>
          </div>
        </div>
        <div class="card" v-else-if="$route.params.m == 2">
          <my-books></my-books>
        </div>
        <div class="card" v-else-if="$route.params.m == 3">
          <order-history></order-history>
        </div>
        <div class="card" v-else-if="$route.params.m == 4">
          <library-check></library-check>
        </div>        
      </div>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { request } from "@/api/all";
import { hasOneOf } from "@/libs/tools";
import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";


const moment = require("moment");

export default {
  components: {
    vueCustomScrollbar,    
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    // libSearch: () => ({
    //   component: import(
    //     "@/views/modules/lms/student/pages/library/components/search.vue"
    //   ),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000,
    // }),
    read: () => ({
      component: import(
        "@/views/modules/lms/student/pages/library/components/read.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    bookDetail: () => ({
      component: import(
        "@/views/modules/lms/student/pages/library/components/bookDetail.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    orderHistory: () => ({
      component: import(
        "@/views/modules/lms/student/pages/library/components/orderHistory.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    libraryCheck: () => ({
      component: import(
        "@/views/modules/lms/student/pages/library/components/libraryCheck.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    libBooks: () => ({
      component: import(
        "@/views/modules/lms/student/pages/library/components/books.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    myBooks: () => ({
      component: import(
        "@/views/modules/lms/student/pages/library/components/myBooks.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    })
  },
  data() {
    return {
      statObj: {
        data: {},
        rdy: false,
      },
      nowDate: null,
      tasks: [],
      allCount: 0,
      categories: [],
      searches: [],
      searchRdy: false,
      searchKey: 0,      
      pager: {
        page: 1,
        size: 10,
      },
      filterModel: {
        task: "",
        systemFlag: null,
      },      
      filterParams:{
        task: '',
        type: 0
      }
    };
  },
  mounted() {
    this.init();
    this.build();
  },
  methods: {
    onFilterLib(e){
      this.filterParams.type= e;
      this.init();
      //console.log('onFilterLib', e);
    },
    loctypeCleared(){
      this.filterParams.type= null;
      this.$refs.stdnthdr.searchHandler();
      //this.filterKey++;
      //console.log('etssiin log');
    },
    doFilter(section, value){
      let _type= 0;
      if(section==5){
        if(value.type>0){
          this.filterParams.type= value.type;
        }else if(value.type==null){
          this.filterParams.type= 0;
        }

        if(value.name!=null && value.name!=""){
          this.filterParams.task= value.name;
        }else{
          this.filterParams.task= '';
        }

        // this.$router.push({
        //   name: 'lmsLibrary',
        //   params: { id: 0, cid: _type, title: (this.filterParams.task=null && this.filterParams.task!='') ? this.filterParams.task : 'Номын сан' }
        // });

        this.init();
      }
      //console.log('doFilter', section, value);
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    getScrollHeight(mv) {
      let mh = 120;
      if (screen.width <= 1024) {
        mh = 85;
      }

      if (mv != undefined) {
        mh = mv;
      }

      return `calc(${window.innerHeight}px - ${mh}px) !important;`;
    },
    build() {
      if (this.$route.params.m == 0 || this.$route.params.m == 101
      || this.$route.params.m == 102  || this.$route.params.m == 103) {
        this.getCategories();
      } else if (this.$route.params.m == 1) {
        this.initSearches();
      }
    },
    
    search(e) {
      this.navbarMode = 1;
      this.toggleNavbar(false);
      if (this.$route.params.id > 0) {
        this.$router.push({
          name: "lmsNotif",
          params: { id: 0, cid: 0, title: "Тушаал Цахилгаан" },
        });
      } else {
        this.filterModel = e;
        this.init();
      }
    },
    pageChanged(e) {
      this.pager.page = e;
      this.init();
    },
    init(force) {
      //console.log('init', this.filterParams, force);
      if (force) {
        if (this.$route.params.id > 0) {
          this.$router.push({
            name: "lmsNotif",
            params: { id: 0, cid: 0, title: "Тушаал Цахилгаан" },
          });
        } else {
          this.filterModel = { task: "", systemFlag: null };
          this.searchKey++;
          this.navbarMode = 1;
          this.toggleNavbar(false);
        }
      }

      if (this.$route.params.m == 0 || this.$route.params.m == 101 || this.$route.params.m == 102 || this.$route.params.m == 103) {
        // console.log('stp 1');
        // console.log('this.filterParams.type', this.filterParams.type, this.$route.params.m);
        let _i2val=null;
        if(this.$route.params.m == 101){
          // _i2val= 2;
          _i2val= null;
        } else if(this.$route.params.m == 102){
          _i2val= 0;
          //# Цахим
        } else if(this.$route.params.m == 103){
          _i2val= 1;
          //# Цаасан
        }
        
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "TaskCore/GetCoreList" },
          data: {
            skip: 0,
            size: 1000,
            ot: 181,
            model: {
              task: this.filterParams.task,
              isPublic: true,
              // isTender: false,
              locTypeId: this.filterParams.type,
                //this.$route.params.cid > 0 ? this.$route.params.cid : null,
              i2: _i2val,
            },
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            // console.log('stp 1.1', res.data.tasks);
            this.allCount = res.data.allCount;
            this.nowDate = res.data.nowDate;
            this.tasks = res.data.tasks;
          }
        });
      } else if (this.$route.params.m == 1) {
        // console.log('stp 2');
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "library/BookList" },
          data: {
            page: this.pager.page - 1,
            size: this.pager.size,
            isTender: true,
            task: this.filterModel["task"],
            locTypeId: null,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            //console.log('GetCoreList', res);
            this.nowDate = res.data.nowDate;
            this.allCount = res.data.allCount;
            this.tasks = res.data.tasks;
          }
        });
      }
    },
    
    
    initSearches() {
      //console.log('srch fired');
      request({
        api: { method: "GET", url: "TaskCore/GetSearchFields" },
        params: {
          objectTypeId: 181,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          let _flds = ["task", "f3", "f1"];
          //console.log(res.data.fields);
          this.searches = res.data.fields
            .filter((x) => hasOneOf(_flds, x["field"]))
            .map((e) => Object.assign(e, { val: "" }));
          this.searchRdy = true;
        }
      });
    },
    getCategories() {
      // console.log('getCategories fired');
      request({
        api: { method: "GET", url: "type/getData" },
        params: {
          key: "lrnbk_type",
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.categories = res.data.types;
        }
      });
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    orderBook(e) {
      request({
        api: { method: "GET", url: "library/HaveOrderForThisBook" },
        params: {
          id: e.id,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          if (res.data.count == 0) {
            //console.log('HaveOrderForThisBook', e, res);
            this.order.coverId = e.defaultAttachmentId;
            this.order.info = res.data.info;
            let _tip = this.$store.state.app.groupSettings.filter(
              (x) => x.key == "libOrderTip"
            );
            if (
              _tip.length > 0 &&
              _tip[0].value != undefined &&
              _tip[0].value != ""
            ) {
              this.order.tip = _tip[0].value;
            }
            this.order.obj = e;

            this.toggleBodyClass("addClass", "dynamic-locker");
            let _ot = this.$store.state.app.groupDefaultProjects.filter(
              (x) => x.objectTypeId == 504
            );
            if (_ot.length) {
              request({
                api: { method: "GET", url: "Task/GetInherited" },
                params: {
                  id: 0,
                  objectTypeId: 504,
                  projectId: _ot[0].id,
                },
                store: this.$store,
              }).then((res) => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if (res != false) {
                  this.order.task = res.data.task;
                  this.order.task.organizationTaskId = this.order.obj.id;
                  this.order.task.secondUserId = this.$store.state.user.userId;
                  this.order.mdl = true;
                }
              });
            }
          } else {
            Notification.warning({
              message: "Та энэ номыг захиалах хүсэлт илгээсэн байна",
              title: "Мэдэгдэл",
              duration: 30000,
              type: "success",
              position: "top-right",
              offset: 50,
            });
          }
        }
      });
    },
    
    
    onItemModal(e) {
      //console.log(e)
      this.order.coverId = e.organizationTask.defaultAttachmentId;
      this.order.itemId = e.organizationTaskId;
      this.order.mdl = true;
    },
   
    
    displayMinute(min) {
      let rv = "";
      if (min > 60) {
        rv =
          (min / 60).toFixed(0).padStart(2, "0") +
          "ц : " +
          (min % 60).toFixed(0).padStart(2, "0") +
          "мин";
      } else if (min == 60) {
        rv = "1цаг";
      } else {
        rv = "00 : " + (min % 60).toFixed(0).padStart(2, "0") + "мин";
      }

      return rv;
    },
    readEbook(t) {
      this.$router.push({
                    name: 'lmsLibrary',
                    params: { id: t.id, cid: 0, title: t.task, m:5 },
                  });
      // this.bkDtl.rdy = false;
      // request({
      //   api: { method: "GET", url: "Task/taskInheritedDetail" },
      //   params: {
      //     id: t.id,
      //   },
      //   store: this.$store,
      // }).then((res) => {
      //   if (res != false) {
      //     this.order.info = res.data.task.taskDesc;
      //     this.order.attachId = res.data.task.secondAttachmentId;
      //     this.order.task = res.data.task;
      //     this.bkDtl.rdy = true;
      //     this.order.mdl = true;
      //   }
      // });
    },
    isNewBook(t) {
      let rv = false;
      var a = moment(t.createdDate);
      var b = moment(this.nowDate);
      if (b.diff(a, "days") <= 14) {
        rv = true;
      }
      return rv;
    },

    

    
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (
        newRoute.params.id > 0 &&
        newRoute.params.cid &&
        newRoute.params.cid > 0 &&
        newRoute.params.m == 0
      ) {
        this.$nextTick(() => {
          this.bookDetail(newRoute.params.id);
        });
      }
      if (newRoute.params.cid != oldRoute.params.cid) {
        this.$nextTick(() => {
          this.init();
        });
      }
      if (newRoute.params.m != oldRoute.params.m) {
        this.tasks = [];
        this.init();
        this.build();
      }
    },
  },
};
</script>


